import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../services/supabase';
import { LoadingSpinner } from './LoadingSpinner';
import { CONTACT_EMAIL, CONTACT_MAILTO } from '../../utils/contactInfo';
import styles from './Auth.module.scss';
import { StaticPageLayout } from '../StaticPages/StaticPageLayout';

export const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const run = async () => {
      try {
        const { data, error: sessionError } = await supabase.auth.getSession();
        if (sessionError) {
          setError(sessionError.message);
          return;
        }
        if (data.session) {
          navigate('/app', { replace: true });
          return;
        }
        setError('We could not verify this link. It may have expired or already been used.');
      } catch {
        setError('Something went wrong while verifying your email. Please try again.');
      }
    };

    run();
  }, [navigate]);

  if (!error) {
    return <LoadingSpinner fullscreen label="Verifying your email…" />;
  }

  return (
    <StaticPageLayout title="Verification problem">
      <div className={styles.authContainer} style={{ minHeight: 'auto', background: 'transparent' }}>
        <div
          className={styles.card}
          style={{ maxWidth: '440px', margin: '0 auto', border: 'none', boxShadow: 'none', background: 'transparent' }}
        >
          <div className={styles.error} role="alert" aria-live="polite">
            {error}
          </div>
          <button
            type="button"
            className={styles.button}
            onClick={() => navigate('/login', { replace: true })}
          >
            Back to login
          </button>
          <div className={styles.link} style={{ marginTop: '1rem', fontSize: '0.85rem' }}>
            Still stuck? <a href={CONTACT_MAILTO}>{CONTACT_EMAIL}</a>
          </div>
        </div>
      </div>
    </StaticPageLayout>
  );
};
